import {ChangeDetectionStrategy, Component, Input,} from '@angular/core';
import {BaseComponent} from 'compob2b-libs';
import {ListFilterService} from '../../services/list-filter.service';
import {AsyncPipe, NgIf} from "@angular/common";

@Component({
    selector: 'app-filter-count',
    template: `
    <ng-container *ngIf="filter.getCtnActiveFeatures() | async as cnt">
      <div class="count-filter">
        {{ cnt }}
      </div>
    </ng-container>
  `,
    styles: ``,
    imports: [
        NgIf,
        AsyncPipe
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FilterCountComponent extends BaseComponent {
  @Input() filter: ListFilterService;

}
